module.exports = "/lucky-balls/img/weager/balls/normal/LB_8.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/normal/LB_8.png
// module id = 1191
// module chunks = 0